import { FragmentType, useMutation } from "@apollo/client";
import { EXPIRE_PERSON_MUTATION } from "../../mutations";
import { useState } from "react";
import { PEOPLE_FOR_LINK_QUERY, PEOPLE_FOR_LINK__PERSON_FRAGMENT, PERSON_FOR_LINK_QUERY } from "../../queries";
import { ExpirePersonMutation, ExpirePersonMutationVariables, PeopleForLinkQuery } from "../../__generated__/graphql";
import { getFragmentData } from "../../__generated__";
// import { useSelectPersonContext } from "../../../context/StaffContext/StaffProvider";
import { PersonDataType } from "../../types";
const useExpirePerson = () => {
  // const { setSelectedPerson } = useSelectPersonContext();
  const [expirePersonMutation, { loading }] =
    useMutation<ExpirePersonMutation, ExpirePersonMutationVariables>(EXPIRE_PERSON_MUTATION);

  const [personToDelete, setPersonToDelete] = useState<string>();

  const expirePerson = async (personId: string) => {
    await expirePersonMutation({
      variables: {
        personId,
      },
      refetchQueries: [{
        query: PERSON_FOR_LINK_QUERY,
        variables: {
          personId
        }
      }],
      update(cache) {
        // const people = cache.readQuery<PeopleForLinkQuery>({ query: PEOPLE_FOR_LINK_QUERY });

        // const newPeople = people?.persons.map(person => {
        //   // const fragment = getFragmentData(PEOPLE_FOR_LINK__PERSON_FRAGMENT, person);
        //   const fragment = getFragmentData(PEOPLE_FOR_LINK__PERSON_FRAGMENT, person as FragmentType<typeof PEOPLE_FOR_LINK__PERSON_FRAGMENT>);
        //   if (fragment.id !== personId) return fragment;

        //   const updateFragment = {
        //     ...fragment,
        //     expired: true
        //   }

        //   // setSelectedPerson(updateFragment as PersonDataType);

        //   return updateFragment
        // });
        // newPeople?.forEach(person => {
        //   cache.writeFragment({
        //     id: cache.identify(person),
        //     fragment: PEOPLE_FOR_LINK__PERSON_FRAGMENT,
        //     data: person
        //   })
        // })
        // cache.writeQuery<PeopleForLinkQuery>({
        //   query: PEOPLE_FOR_LINK_QUERY,
        //   data: { persons: newPeople as PeopleForLinkQuery['persons'] ?? [] }
        // });
      }
    })
  }


  const onExpirePerson = async (id: string) => {
    await expirePerson(id);
    setPersonToDelete(undefined);
  };

  return { expirePerson, onExpirePerson, savingExpirePerson: loading, setPersonToDelete, personToDelete };
};

export { useExpirePerson };
